const moment = require("jalali-moment");

const date = moment().locale("fa");

const fixDate = (d) => {
  const date = new Date(d);
  return date.setSeconds(date.getSeconds() + 210 * 60);
};

const headerInfoDate = date.format("dddd - YYYY/M/D");

const loginHistoryDate = (d) => {
  return moment(fixDate(d)).locale("fa").format("YYYY/M/D");
};

const loginHistoryTime = (d) => {
  return moment(fixDate(d)).locale("fa").format("HH:mm:ss");
};

const loginHistoryDay = (d) => {
  return moment(fixDate(d)).locale("fa").format("dddd");
};

const loginHistoryDayName = (d) => {
  return moment(fixDate(d)).locale("fa").format("D");
};

const loginHistoryMonthName = (d) => {
  return moment(fixDate(d)).locale("fa").format("MMMM");
};

const faDateTime = (d) => {
  // added one hour for handling daylight saving change
  return moment(fixDate(d)).locale("fa").format("YYYY/M/D - HH:mm:ss");
};

const unixTimeToDatetime = (timestamp) => {
  return faDateTime(moment.unix(timestamp).format("MM/DD/YYYY"));
};

const getGregorianDate = (d) => {
  const m = moment.from(d, "fa", "YYYY/MM/DD");
  return m.format("YYYY-MM-DD");
};

export default {
  headerInfoDate,
  loginHistoryTime,
  loginHistoryDate,
  loginHistoryDay,
  loginHistoryDayName,
  loginHistoryMonthName,
  faDateTime,
  fixDate,
  getGregorianDate,
  unixTimeToDatetime,
};
